<template>
    <div class="map-box">
        <div class="map-canvas" ref="mapRef"></div>

        <div class="loading" v-if="loading">
            <i class="el-icon-loading"></i>
        </div>

        <span class="tip" v-if="error && !loading">未定位到工作地址</span>

        <div class="position flex-center" v-if="!error && !loading && operate" @click="setCenter()">
            <img src="@/assets/map-center.svg" alt="" />
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            loading: true,
            error: false,
            map: undefined,
        };
    },

    props: {
        location: {
            type: String,
            required: true,
        },

        // 是否可以滚轮缩放
        scrollWhell: {
            type: Boolean,
            default: false,
        },

        // 是否可以拖拽
        draggable: {
            type: Boolean,
            default: false,
        },

        iconSize: {
            type: Number,
            default: 24,
        },

        zoom: {
            type: Number,
            default: 15,
        },

        operate: {
            type: Boolean,
            default: false,
        },
    },

    methods: {
        setMap() {
            const locationArr = this.location.split(",");

            if (locationArr.length < 2) {
                this.loading = false;
                this.error = true;

                return;
            }

            AMapLoader.load({
                key: "909761a92756a10999f4491844b7230b", //申请好的Web端开发者key，调用 load 时必填
                version: "2.0", //指定要加载的 JS API 的版本，缺省时默认为 1.4.15
            })
                .then((AMap) => {
                    this.loading = false;

                    //JS API 加载完成后获取AMap对象
                    this.map = new AMap.Map(this.$refs.mapRef, {
                        viewMode: "2D", //默认使用 2D 模式
                        zoom: this.zoom, //地图级别
                        center: locationArr, //地图中心点
                        scrollWheel: this.scrollWhell,
                        dragEnable: this.draggable,
                    });

                    this.addMarkers(locationArr);

                    if (this.operate) this.addTools();
                })
                .catch((e) => {
                    this.loading = false;
                    this.error = true;

                    console.error(e); //加载错误提示
                });
        },

        // 工具栏
        addTools() {
            const plugins = ["AMap.ToolBar", "AMap.Scale", "AMap.Geolocation"];
            this.map.plugin(plugins, () => {
                const tool = new AMap.ToolBar();
                const scale = new AMap.Scale();

                this.map.addControl(tool);
                this.map.addControl(scale);
            });
        },

        // 标记
        addMarkers(location) {
            const marker = new AMap.Marker({
                position: new AMap.LngLat(location[0], location[1]),
                anchor: "bottom-center",
                icon: new AMap.Icon({
                    size: [this.iconSize, this.iconSize],
                    imageSize: [this.iconSize, this.iconSize],
                    image: require("../../../assets/map-position.svg"),
                }),
            });

            this.map.add(marker);
        },

        // 设置中心位置
        setCenter(duration = 0.1) {
            const locationArr = this.location.split(",");

            this.map.setCenter(locationArr, false, duration * 1000);
            this.map.setZoom(17, false, duration * 1000);
        },
    },

    mounted() {
        if (this.location) {
            console.log("location: ", this.location);
            this.setMap();
        }
    },

    beforeDestroy() {
        if (this.map) this.map.destory?.();
    },
};
</script>

<style lang="scss" scoped>
.map-box {
    width: 100%;
    height: 100%;
    background-color: #fbf8f0;
    position: relative;

    .map-canvas {
        width: 100%;
        height: 100%;
    }

    .loading,
    .tip {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
    }

    .loading {
        font-size: 30px;
        color: #999;
    }

    span.tip {
        color: #999;
    }

    .position {
        position: absolute;
        right: 18px;
        bottom: 90px;
        width: 35px;
        height: 35px;
        border-radius: 50%;
        background-color: #ffffff;
        box-shadow: 0 0 3px rgba(0, 0, 0, 0.5);
        cursor: pointer;

        &:hover {
            background-color: #f0f0f0;
        }

        img {
            width: 80%;
            height: 80%;
            object-fit: cover;
        }
    }
}
</style>
